import { apiPrefix } from "@/config/config";
import { api } from "../interceptor/api.interceptor";

class HomePageService {
  static async getSiteSetting() {
    return await api
      .get(`/${apiPrefix}/sitesetting`)
      .then((res) => res?.data?.data);
  }
  static async getBannerFeatures() {
    return await api
      .get(`/${apiPrefix}/banner_features`)
      .then((res) => res?.data?.data);
  }
  static async getPrograms() {
    return await api
      .get(`/${apiPrefix}/programs`)
      .then((res) => res?.data?.data);
  }

  static async getServices() {
    return await api
      .get(`/${apiPrefix}/services`)
      .then((res) => res?.data?.data);
  }

  static async getServiceDetails(slug) {
    return await api
      .get(`/${apiPrefix}/services/${slug}`)
      .then((res) => res?.data?.data);
  }

  static async getAllCourses() {
    return await api
      .get(`/${apiPrefix}/courses`)
      .then((res) => res?.data?.data);
  }

  static async getCourseSubjects(id) {
    return await api
      .get(`/${apiPrefix}/course/${id}/subjects`)
      .then((res) => res?.data?.data);
  }

 static async getCoursesByProgram(slug, page = 1) {
  return await api
    .get(`/${apiPrefix}/programs/${slug}/courses`, {
      params: { page }
    })
    .then((res) => res?.data?.data);
}
  static async getProgramWiseCourses(params) {
    return await api
      .get(`/${apiPrefix}/programWiseCourses`, { params })
      .then((res) => res?.data?.data);
  }

  static async getVideosStories() {
    return await api
      .get(`/${apiPrefix}/videos-stories`)
      .then((res) => res?.data?.data);
  }

  static async getFeatureInstructor() {
    return await api
      .get(`/${apiPrefix}/featureInstructor`)
      .then((res) => res?.data?.data);
  }

  static async getFaqs() {
    return await api.get(`/${apiPrefix}/faqs`).then((res) => res?.data?.data);
  }
}

export default HomePageService;
